import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { POSITIVE_SHORTAGE_STATUSES } from 'src/app/defaults/product.defaults';
import {
  ShortageStatus,
  ShortageStatusNames,
} from 'src/app/entities/products/enums/shortage-status.enum';

@Component({
  standalone: true,
  selector: 'sandoz-product-status-string',
  templateUrl: './product-status-string.component.html',
  styleUrls: ['./product-status-string.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule],
})
export class ProductStatusStringComponent {
  private _productStatus!: ShortageStatus;
  private _useColor: boolean = true;

  ShortageStatus = ShortageStatus;
  ShortageStatusNames = ShortageStatusNames;

  @HostBinding('class') hostClass: string = '';

  @Input({ required: true })
  set productStatus(v: ShortageStatus) {
    if (typeof v === 'string')
      throw new Error('Wrong type for shortage status');
    else this._productStatus = v;

    this.updateHostClass();
  }
  get productStatus(): ShortageStatus {
    return this._productStatus;
  }

  @Input()
  set useColor(v: boolean) {
    this._useColor = v;
    this.updateHostClass();
  }
  get useColor(): boolean {
    return this._useColor;
  }

  updateHostClass(): void {
    if (this.useColor) {
      if (POSITIVE_SHORTAGE_STATUSES.includes(this.productStatus))
        this.hostClass = 'primary';
      else this.hostClass = 'warn';
    } else {
      this.hostClass = '';
    }
  }
}
